<template lang="html">
  <div class="content editor">
    <ModelNav class="editor__nav" @nav-clicked="onNavClicked" />
    <div class="editor__content">
      <transition name="fade" mode="out-in" appear>
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import ModelNav from '@/components/editor/model-nav.vue';

export default {
  components: { ModelNav },
  methods: {
    onNavClicked(route) {
      this.$router.push(route);
    }
  }
};
</script>

<style lang="scss" scoped>
.editor {
  width: 100%;
  display: flex;
  overflow-y: hidden;

  &__content {
    flex: 1;
    width: calc(100% - 130px);
    overflow-y: scroll;
  }
}
</style>
